<template>
  <md-card v-if="data.length" class="pt-10 ielts-table-top-bottom">
    <md-card-header class="md-card-header-text md-card-header-green pl-2">
      <div class="card-text">
        <p class="title text-lg ">
          {{ $t("assignment_overall.ielts_top_bottom") }}
        </p>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-70">
          <p class="pt-8">
            {{
              $t("assignment_overall.total_student", { length: data.length })
            }}
          </p>
        </div>
        <div class="md-layout-item md-size-30">
          <md-field>
            <md-select
              v-model="selectedTopBottom"
              :name="selectTopBottom.name"
              :id="selectTopBottom.name"
              :multiple="selectTopBottom.multiple"
            >
              <md-option
                v-for="option in selectTopBottom.options"
                :value="option.id"
                :key="option.id + option.name"
                >{{ $t(option.name) }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <md-table class="table-top-bottom">
        <md-table-row>
          <md-table-head rowspan="2">
            {{ $t("assignment_overall.student") }}
          </md-table-head>
          <md-table-head rowspan="2">
            {{ $t("assignment_overall.overall") }}</md-table-head
          >
          <md-table-head rowspan="2">
            {{ $t("assignment_overall.test_date") }}
          </md-table-head>
          <md-table-head rowspan="2">
            {{ $t("assignment_overall.listening") }}
          </md-table-head>
          <md-table-head rowspan="2">
            {{ $t("assignment_overall.reading") }}
          </md-table-head>
          <md-table-head rowspan="1" :colspan="colWriting" class="px-0"
            ><div class="flex gap-4">
              <span> {{ $t("assignment_overall.writing") }}</span>
              <span @click="showDetailWriting" class="cursor-pointer"
                ><i v-if="colWriting === 1" class="fas fa-eye "></i>
                <i v-else class="fas fa-eye-slash"></i
              ></span></div
          ></md-table-head>
          <md-table-head rowspan="1" colspan="6"
            ><div class="flex gap-4">
              <span> {{ $t("assignment_overall.speaking") }}</span>
              <span @click="showDetailSpeaking" class="cursor-pointer"
                ><i v-if="colSpeaking === 1" class="fas fa-eye "></i>
                <i v-else class="fas fa-eye-slash"></i
              ></span></div
          ></md-table-head>
        </md-table-row>
        <md-table-row>
          <md-table-head>
            {{ $t("assignment_overall.band_score_s") }}</md-table-head
          >
          <md-table-head v-show="colWriting === colWiringDetail">
            {{ $t("assignment_overall.task_1") }}</md-table-head
          >
          <md-table-head v-show="colWriting === colWiringDetail">
            {{ $t("assignment_overall.task_2") }}</md-table-head
          >
          <md-table-head>
            {{ $t("assignment_overall.test_date_s") }}</md-table-head
          >
          <md-table-head>
            {{ $t("assignment_overall.band_score_s") }}</md-table-head
          >
          <md-table-head v-show="colSpeaking === colSpeakingDetail"
            >GR</md-table-head
          >
          <md-table-head v-show="colSpeaking === colSpeakingDetail"
            >LR</md-table-head
          >
          <md-table-head v-show="colSpeaking === colSpeakingDetail"
            >FC</md-table-head
          >
          <md-table-head v-show="colSpeaking === colSpeakingDetail"
            >P</md-table-head
          >
        </md-table-row>
        <md-table-row v-for="(item, index) in data" :key="item + index">
          <md-table-cell
            ><div class="flex items-center w-52" v-if="item.user">
              <img
                :src="item.user.avatar_url || '/img/avt_placeholder.jpg'"
                class="object-cover rounded-full w-[42px] h-[42px]"
              />
              <div class="text-left pl-4">
                <p class="font-medium">{{ item.user.full_name }}</p>
                <p class="font-medium">{{ item.user.student_code }}</p>
              </div>
            </div>
          </md-table-cell>
          <md-table-cell>{{ item.overall }}</md-table-cell>
          <md-table-cell>{{
            convertDateFromServer(item.listening.test_date_s, "date")
          }}</md-table-cell>
          <md-table-cell>{{ item.listening.score }}</md-table-cell>
          <md-table-cell>{{ item.reading.score }}</md-table-cell>
          <md-table-cell>{{ item.writing.band_score_w }}</md-table-cell>
          <md-table-cell v-show="colWriting === colWiringDetail">{{
            item.writing["task 1"]
          }}</md-table-cell>
          <md-table-cell v-show="colWriting === colWiringDetail">{{
            item.writing["task 2"]
          }}</md-table-cell>
          <md-table-cell>{{
            convertDateFromServer(item.speaking.test_date_s, "date")
          }}</md-table-cell>
          <md-table-cell>{{ item.speaking.band_score_s }}</md-table-cell>
          <md-table-cell v-show="colSpeaking === colSpeakingDetail">{{
            item.speaking.GR
          }}</md-table-cell>
          <md-table-cell v-show="colSpeaking === colSpeakingDetail">{{
            item.speaking.LR
          }}</md-table-cell>
          <md-table-cell v-show="colSpeaking === colSpeakingDetail">{{
            item.speaking.FC
          }}</md-table-cell>
          <md-table-cell v-show="colSpeaking === colSpeakingDetail">{{
            item.speaking.P
          }}</md-table-cell>
        </md-table-row>
      </md-table>
      <yv-pagination
        :pagination="pagination"
        @changePage="changePage"
      ></yv-pagination>
    </md-card-content>
  </md-card>
</template>
<script>
import { YvPagination } from "@/components/Base";
import { convertDateFromServer } from "../../../../helpers/datetime-helper";

const optionsTopBottom = [
  { name: "assignment_overall.top_overall", id: "overall desc" },
  { name: "assignment_overall.top_listening", id: "listening desc" },
  { name: "assignment_overall.top_reading", id: "reading desc" },
  { name: "assignment_overall.top_speaking", id: "speaking desc" },
  { name: "assignment_overall.top_writing", id: "writing desc" },
  { name: "assignment_overall.bottom_overall", id: "overall asc" },
  { name: "assignment_overall.bottom_listening", id: "listening asc" },
  { name: "assignment_overall.bottom_reading", id: "reading asc" },
  { name: "assignment_overall.bottom_speaking", id: "speaking asc" },
  { name: "assignment_overall.bottom_writing", id: "writing asc" }
];
const defaultCol = {
  writing: 1,
  speaking: 1,
  writingDetail: 3,
  speakingDetail: 5
};
export default {
  props: ["data", "pagination", "actionSearch"],
  components: { YvPagination },
  data() {
    return {
      colWriting: defaultCol.writing,
      colSpeaking: defaultCol.speaking,
      colWiringDetail: defaultCol.writingDetail,
      colSpeakingDetail: defaultCol.speakingDetail,
      params: {},
      selectedTopBottom: "overall desc",
      selectTopBottom: {
        label: "common.status",
        name: "status__",
        value: "",
        type: "select",
        options: optionsTopBottom
      },
      convertDateFromServer
    };
  },
  watch: {
    selectedTopBottom: function(newVal) {
      this.$emit("changeTopbottom", newVal);
    }
  },
  methods: {
    changePage() {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.actionSearch.action(this.params);
    },
    showDetailWriting() {
      this.colWriting =
        this.colWriting === defaultCol.writingDetail
          ? defaultCol.writing
          : defaultCol.writingDetail;
    },
    showDetailSpeaking() {
      this.colSpeaking =
        this.colSpeaking === defaultCol.speakingDetail
          ? defaultCol.speaking
          : defaultCol.speakingDetail;
    }
  }
};
</script>
<style lang="scss">
.ielts-table-top-bottom {
  .md-table-head-label {
    padding-right: 0 !important;
  }
  .md-table-cell-container {
    text-align: center;
  }
  .table-top-bottom {
    .md-table-head {
      padding: 12px 8px;
      text-align: center;
      border: 0.5px solid #b8b7b7;
      .md-table-cell {
        border: 0.5px solid #b8b7b7 !important;
      }
    }
    .md-table-cell {
      border: 0.5px solid #b8b7b7 !important;
    }
  }
}
</style>
